import styled from 'styled-components/macro'

import { Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${getToken('space-m')};
  text-align: initial;
`

export const Columns = styled.div`
  display: flex;
  gap: ${getToken('space-m')};
`

export const Item = styled.article`
  background-color: ${getToken('color-neutral-lightest')};
  padding: ${getToken('space-m')};
`

export const Stops = styled(Item)`
  display: flex;
  flex-direction: column;
  gap: ${getToken('space-m')};
`

export const Location = styled(Text).attrs({ as: 'div', variant: 'body-bold' })`
  text-transform: capitalize;
`

export const Commodity = styled(Item)`
  flex-grow: 1;
`

export const Footer = styled(Columns)`
  background-color: ${getToken('color-neutral-lighter')};
`

export const FooterItem = styled.article`
  padding: ${getToken('space-m')};
`

export const Rate = styled(FooterItem)`
  flex-grow: 1;
  text-align: right;
`
